export default __webpack_public_path__ + "static/slide-1-4a403fec18ea5bc4ef62e083cead5076.jpg";